import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";

class CorporateDataService {
  getAllCorporate = () => {
    return getDocs(collection(db, "corporate"));
  };
  getCorporateById = (id) => {
    const hubDocRef = doc(db, "corporate", id);
    return getDoc(hubDocRef);
  };
}
export default new CorporateDataService();
